import React from 'react';

// import components
import AlertBar from 'components/partials/alert-bar';

const InPageAlertComponentBuilder: React.FC<{ inPageAlertData?: Queries.InPageAlertBlockFragment }> = ({ inPageAlertData }) => {

    if (!inPageAlertData) return null;

    // we know we're building an in-page alert, so we can set some defaults
    let modifierClass = 'alert-bar--inpage';

    // convert startDatetime and endDatetime to Date objects
    let startDatetime = undefined;
    if (inPageAlertData.startDatetime) {
        startDatetime = new Date(inPageAlertData.startDatetime);
    }

    let endDatetime = undefined;
    if (inPageAlertData.endDatetime) {
        endDatetime = new Date(inPageAlertData.endDatetime);
    }

    const alertData = {
        id: inPageAlertData.id || '',
        modifierClass: modifierClass || '',
        type: inPageAlertData.iconName || 'warning',
        headline: inPageAlertData.title || '',
        content: inPageAlertData.text || '',
        link: inPageAlertData.link || undefined,
        startDate: startDatetime || undefined,
        endDate: endDatetime || undefined,
        isDismissable: inPageAlertData.isDismissible ?? true,
    };

    return (
        <AlertBar
            id={alertData.id}
            modifierClass={alertData.modifierClass}
            type={alertData.type}
            headline={alertData.headline}
            content={alertData.content}
            link={alertData.link}
            startDate={alertData.startDate}
            endDate={alertData.endDate}
            isDismissable={alertData.isDismissable}
        />
    );
};

export default InPageAlertComponentBuilder;